/**
 * Window events used to reach a specific mounted workspace component from code
 * that has no React context — currently the command registry and the native
 * application menu's `shell:` actions.
 *
 * The pattern predates this file (`jam:query-editor:toggle-results-pane`, still
 * a literal in `workspaceCommands.ts` / `QueryEditorTab.tsx`); new events are
 * declared here so the dispatcher and the listener cannot drift apart.
 */

/**
 * Ask the tab strip to close the ACTIVE tab through its own guarded path
 * (`Tabs.tsx` → `handleCloseTab`), which prompts on an open/errored
 * transaction, an unsaved notebook, or a live data-import run.
 *
 * Never call `workspaceStore.removeTab` directly for a user-initiated close —
 * that skips every one of those guards.
 */
export const WORKSPACE_CLOSE_ACTIVE_TAB_EVENT = 'jam:workspace:close-active-tab';
